<template>
  <div class="seo-widget-edit-wrap relative">
    <div class="tip text-12">请使用规格512*512的图片，否则PWA应用图标将无法正常显示</div>
    <menu-item class="menu-item-switch" :label="$t('seo.favicon')">
      <menu-background-image :target="model" :size="[512, 512]" image-key="favicon" />
    </menu-item>
    <menu-item class="menu-item-switch" :label="$t('seo.inputShareTitle')">
     <base-input v-model="model.title" :value="model.title"/>
    </menu-item>
    <menu-item class="menu-item-switch" :label="$t('seo.inputShareDesc')">
      <base-input v-model="model.desc" :value="model.desc"/>
    </menu-item>
    <menu-item class="menu-item-switch" :label="$t('seo.shareImage')">
      <menu-background-image :target="model" :size="[1200, 630]" image-key="shareImage" />
    </menu-item>
    <div class="tip text-12 mt-2">{{ $t('seo.shareImageTip') }}</div>
  </div>
</template>

<script>
import { SeoSettingModel } from '../../model'
import BaseInput from '~/components/base/baseInput'
import MenuItem from "~/components/menu/menuItem"
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage"

export default {
  name: "SeoSettingEdit",
  components:{
    MenuItem,
    BaseInput,
    MenuBackgroundImage,
  },
  props:{
    model: {
      type: Object,
      default(){
        return new SeoSettingModel()
      }
    }
  },
  data(){
    return {
      tmpModel: {}
    }
  },
  methods:{
    handleShowBackgroundMenu(suggestion){
      this.SiteMenu.open({
        key: 'background',
        target: this.model,
        config: {
          imageKey: 'favicon',
          colorKey: '',
          imageSizeKey: '',
          suggestion
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.save-btn{
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 120px;
  background: @primary-color;
  color: @text-color ;
  font-size: 16px;
  &:hover {
    color: @text-light-color;
  }
}
</style>